import { Injectable } from '@angular/core';
import { MetadataProp } from '../models/metadata-prop-model';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { QueryStateService } from '../services/query-state.service';
import { MetadataService } from '../services/metadata.service';
import { Observable, filter, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MetadataResolverService implements Resolve<MetadataProp[]> {

  constructor(private svc: MetadataService, private querySvc: QueryStateService, private mdSvc: MetadataService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MetadataProp[]> {
    return this.svc.getMetadata().pipe(tap(data => {
      this.querySvc.updateMetadataProps(data);
      // this.mdSvc.mdItems = data;
      this.mdSvc.setData(data);
    }));
  }
}
